import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
import { digitalHubInterceptor } from './digital-hub.interceptor';
import { b2bPortalInterceptor } from './b2b-portal.interceptor';
import { httpCacheInterceptor } from '../cache/http-cache.interceptor';
import { AppName } from '@shared/enums/app-name.enum';

export function getAppInterceptors(): HttpInterceptorFn[] {
  const appInterceptor =
    environment.appName === AppName.AdminConsole
      ? digitalHubInterceptor
      : b2bPortalInterceptor;

  return [appInterceptor, httpCacheInterceptor];
}
